
import api from '@/api';

const namespaced = true;

const state = {
  userVisits: [],
};

const mutations = {
  SET_USER_VISITS(state, userVisits) {
    state.userVisits = userVisits;
  },
};

const actions = {
  async fetchUserVisits({ commit }) {
    const { data: userVisits } = await api.get(`/user-visits/by-user`);
    commit(`SET_USER_VISITS`, userVisits);

    return userVisits;
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
